import {Component, Input, OnInit} from '@angular/core';
import {PageStats} from '@core/models';
import { DecimalPipe } from "@angular/common";

@Component({
    selector: 'app-stat-list',
    templateUrl: './stat-list.component.html',
    styleUrls: ['./stat-list.component.scss'],
    imports: [
    DecimalPipe
]
})
export class StatListComponent implements OnInit {
  @Input() statList!: PageStats[];
  @Input() isProfileView: boolean = false;

  constructor() {
  }

  ngOnInit(): void {
  }

}
